import { DebouncedTextFilterCell } from "~/shared/components/trax-grid/debounced-text-filter-cell/debounced-text-filter-cell.tsx";
import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { GlobalCarrier } from "~/shared/schemas/auto-dispatch-schema.ts";

import type { column } from "./types.ts";
import type { CellWrapper } from "./with-loader.tsx";

export const carrierNameColumn = (cellWrapper: CellWrapper): column => ({
	field: "carrierName",
	title: "Carrier",
	group: ["global", "customer"],
	filterable: true,
	filterCell: DebouncedTextFilterCell,
	cells: {
		data: cellWrapper((props) => {
			return (
				<GridTd tdProps={props.tdProps}>
					{(props.dataItem as GlobalCarrier)?.carrierName} -{" "}
					{(props.dataItem as GlobalCarrier)?.carrierId}
				</GridTd>
			);
		}),
	},
});
